import { CASE_SIDEBAR_SECTIONS, SECTION_TITLE_KEYS } from '@components/CaseSidebar/config/sections';
import { ITEM_TITLE_KEYS } from '@components/CaseSidebar/config/items';
import { resolveItemIsDisabled, resolveItemSubTitle, resolveItemWarnings } from './resolve/itemFields';
import { getVisibleItemIdsForSection } from './resolve/visibleSidebarItems';
import { CaseSidebarItemId } from './types';
import type { BuildBtlCaseSidebarParams, BuildBtlCaseSidebarResult, CaseSection, CaseSectionItem } from './types';

function buildSectionItem(itemId: CaseSidebarItemId, params: BuildBtlCaseSidebarParams): CaseSectionItem {
  return {
    id: itemId,
    title: params.formatMessage({ id: ITEM_TITLE_KEYS[itemId] }),
    subTitle: resolveItemSubTitle(itemId, params.application),
    isDisabled: resolveItemIsDisabled(itemId, params),
    component: params.components[itemId] ?? null,
    warnings: resolveItemWarnings(itemId, params),
  };
}

function buildSections(params: BuildBtlCaseSidebarParams): CaseSection[] {
  const featureFlags = params.featureFlags ?? {};

  return CASE_SIDEBAR_SECTIONS.reduce<CaseSection[]>((result, section) => {
    const children = getVisibleItemIdsForSection(section, params.application, featureFlags).map(itemId =>
      buildSectionItem(itemId, params),
    );

    if (children.length === 0) {
      return result;
    }

    result.push({
      title: params.formatMessage({ id: SECTION_TITLE_KEYS[section] }),
      children,
    });

    return result;
  }, []);
}

export function buildBtlCaseSidebar(params: BuildBtlCaseSidebarParams): BuildBtlCaseSidebarResult {
  return {
    overviewItem: buildSectionItem(CaseSidebarItemId.OVERVIEW, params),
    state: {
      sections: buildSections(params),
      isTopSlicing: params.application.isTopSlicing,
    },
  };
}
